/* eslint-disable prettier/prettier */
import { Icon } from 'common/icon';

export const tagsData = {
  'Top 10': { color: '#F4EB13' },
  Crypto: { color: '#13F4A3' },
  New: { color: '#1DE40B' },
  'Player ACC': { color: '#FFAB09' },
  Blacklisted: { color: '#121212' },
  'Low RTP': {
    color: '#FC2C2C',
    icon: (
      <Icon.Alert fill="transparent" strokeWidth="2" width="14" height="14" />
    ),
  },
  'High RTP': {
    color: '#CAF413',
    icon: <Icon.Like color="black" width={14} height={14} />,
  },
  'Average RTP': { color: '#800080' },
  Trusted: { color: '#4A90E2' },
};
